import * as React from 'react'
import { Column, TicketRow, SortDirection, AdobePreviewFileOptions } from './types'
import { SortIcon } from './sort_icon'
import { renderCellValue } from './cell_renderers'
import I18n from '../../../libs/i18n'

const cellClassName = (columnKey: string): string | undefined =>
  columnKey === 'comment_attachments' ? 'projects-table-photos' : undefined

interface TicketsTableProps {
  columns: Column[]
  rows: TicketRow[]
  timeZone: string
  sortKey: string | null
  sortDirection: SortDirection
  onSort: (key: string) => void
  adobePreviewFileOptions?: AdobePreviewFileOptions
}

export default function TicketsTable({
  columns,
  rows,
  timeZone,
  sortKey,
  sortDirection,
  onSort,
  adobePreviewFileOptions,
}: TicketsTableProps) {
  if (rows.length === 0) {
    return (
      <div className="alert alert-info">
        {I18n.t('project_groups.overview.no_tickets')}
      </div>
    )
  }

  return (
    <div className="table_wrapper">
      <table className="table table-sm projects-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                onClick={() => onSort(column.key)}
                style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                {column.label}
                <SortIcon
                  columnKey={column.key}
                  sortKey={sortKey}
                  sortDirection={sortDirection}
                />
              </th>
            ))}
            <th className="js-dt-actions" />
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((column) => (
                <td key={column.key} className={cellClassName(column.key)}>
                  {renderCellValue(row.values[column.key], column, row.id, timeZone, adobePreviewFileOptions)}
                </td>
              ))}
              <td className="actions text-nowrap text-right">
                <a href={row.show_path}>{I18n.t('application.actions.show')}</a>
                {row.edit_path && (
                  <>
                    <span className="text-muted mx-1">|</span>
                    <a href={row.edit_path}>{I18n.t('application.actions.edit')}</a>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className="text-right pt-3" colSpan={columns.length + 1}>
              <strong>{I18n.t('application.titles.total')}</strong>:
              <span className="ml-2">
                {rows.length} {I18n.t('activerecord.models.project_ticket', { count: rows.length })}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
